import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import FocusTrap from 'focus-trap-react'
import classNames from 'classnames'

import {
  dispatchHideOverlayEvent,
  dispatchShowOverlayEvent,
  useOutsideClick,
} from '../../../utils'

import FlyoutBody from './FlyoutBody'
import FlyoutHeader from './FlyoutHeader'

function FlyoutMenu({
  isVisible = false,
  hide,
  className,
  children,
  anchor = 'right',
}) {
  const ref = useRef(null)

  const wrapperClasses = classNames('flyout-menu', className, {
    [`flyout-menu--anchor-${anchor}`]: ['left', 'right'].includes(anchor),
    'flyout-menu--visible': isVisible,
  })

  useEffect(() => {
    if (isVisible) {
      dispatchShowOverlayEvent()
    }
    return () => {
      dispatchHideOverlayEvent()
    }
  }, [isVisible])

  useOutsideClick(ref, hide)

  return (
    <FocusTrap active={isVisible} focusTrapOptions={{ onDeactivate: hide }}>
      <div
        ref={ref}
        className={wrapperClasses}
        // Workaround to get the 'inert' HTML attribute to work with our outdated React version.
        // Note: This will break with React 19.
        // See also https://github.com/facebook/react/pull/24730#issuecomment-1698134555
        inert={!isVisible ? '' : null}
      >
        {children}
      </div>
    </FocusTrap>
  )
}

FlyoutMenu.propTypes = {
  isVisible: PropTypes.bool,
  hide: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  anchor: PropTypes.oneOf(['left', 'right']),
}

export default FlyoutMenu
export { FlyoutHeader, FlyoutBody }
